// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Chargement de la modification…',
  load_failed: "Je n'ai pas pu charger cette modification.",
  load_retry: 'Réessayer',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: "Cela a déjà été approuvé, il n'y avait donc plus rien à faire.",
  action_failed: "L'action n'a pas abouti, rien n'a donc été modifié. Réessayez dans un instant.",
  removed: 'Supprimé',
  retry: 'Réessayer',
  retry_one: 'Réessayer {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approuvé.',
    retried: 'Nouvelle tentative effectuée.',
    rejected: 'Refusé.',
  },
  done: {
    summary_one: 'Terminé. {{count}} modification appliquée.',
    summary_other: 'Terminé. {{count}} modifications appliquées.',
    skipped_one: "{{count}} ignorée, rien n'a changé pour elle.",
    skipped_other: "{{count}} ignorées, rien n'a changé pour elles.",
  },
  partial: {
    summary_one: '{{applied}} modifications sur {{approved}} appliquées. {{count}} non appliquées.',
    summary_other: '{{applied}} modifications sur {{approved}} appliquées. {{count}} non appliquées.',
    detail_one: "Les {{applied}} sont enregistrées. Rien n'a changé pour les {{count}} ci-dessous.",
    detail_other: "Les {{applied}} sont enregistrées. Rien n'a changé pour les {{count}} ci-dessous.",
  },
  stale: {
    summary: '{{applied}} modifications sur {{approved}} appliquées.',
    detail_one: "{{count}} a été modifiée par quelqu'un d'autre entre-temps.",
    detail_other: "{{count}} ont été modifiées par quelqu'un d'autre entre-temps.",
    reason:
      "{{name}} l'a changé en {{value}} à {{time}}, avant votre approbation, je l'ai donc laissé tel quel. Le voici à nouveau à partir de la nouvelle valeur :",
  },
  undone: {
    summary_one: "Annulé. La {{count}} modification est revenue à l'état précédent.",
    summary_other: "Annulé. Les {{count}} modifications sont revenues à l'état précédent.",
    detail:
      "L'annulation est également enregistrée dans le journal d'Amigo et dans Menu → Historique des modifications.",
  },
  summary: {
    average: '{{amount}} par plat en moyenne',
    needs_look: 'À vérifier',
    nothing_else: "Rien d'autre ne change",
  },
  labels: {
    waiting: "En attente d'approbation",
    skip: 'Ignorer',
    unskip: "Annuler l'ignorance",
    approve_all: 'Tout approuver',
    approve_one: 'Approuver {{count}}',
    approve_other: 'Approuver {{count}}',
    approve_row: 'Approuver',
    reject: 'Refuser…',
    reject_confirm: 'Refuser',
    back: 'Retour',
    why: {
      amigo: 'Pourquoi pas ? (facultatif, Amigo le lit)',
      assistant: "Pourquoi pas ? (facultatif, l'assistant le lit)",
    },
    hint: 'Ou répondez ci-dessous pour modifier quelque chose.',
    show_all_one: 'Afficher les {{count}} modifications',
    show_all_other: 'Afficher les {{count}} modifications',
    show_less: 'Afficher moins',
    applying_one: 'Application de {{count}} modification…',
    applying_other: 'Application de {{count}} modifications…',
    rows: {
      skipped: 'Ignorée',
      applied: 'Appliquée',
      failed: 'Non appliquée',
      changed: 'Modifiée entre-temps',
      kept: 'Laissée telle quelle',
    },
    history: {
      amigo: "Ouvrir dans le journal d'Amigo",
      assistant: "Ouvrir dans le journal de l'assistant",
    },
    undo: 'Annuler',
    to: 'en',
    from: 'de',
    rejected: 'Refusée',
    replaced: 'Remplacée',
    expired: 'Expirée',
  },
};
